import { EventListScreen } from '../features/events/screens/EventListScreen';

export const EventListPage = () => <EventListScreen />;
